import React, { Component, Fragment } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CATEGORY_COLORS = {
  "LOAN": "purple",
  "INVEST": "blue",
  "OTHERS": "gray",
  "ORDERS": "green",
  "DAILY COST": "orange",
  "OFFICE": "teal",
  "SALARY": "pink",
  "SHIPPING": "indigo",
  "BOOSTING": "amber",
  "REFUND": "red",
  "TRANSPORT": "cyan",
  "BUY PRODUCTS": "violet",
};

function categoryColorClass(category) {
  const key = String(category || "").toUpperCase().trim();
  return `mh-badge--${CATEGORY_COLORS[key] || "gray"}`;
}

const SUBCATEGORY_COLORS = {
  "INSTOCK":  "teal",
  "PREORDER": "amber",
};

function subCategoryBadge(subCategory) {
  const raw = String(subCategory || "").replace(/^undefined-/, "");
  const key = raw.toUpperCase().trim();
  if (SUBCATEGORY_COLORS[key]) {
    return (
      <span className={`mh-badge mh-badge--${SUBCATEGORY_COLORS[key]}`}>
        {raw}
      </span>
    );
  }
  return raw;
}

export class Datatable extends Component {
  render() {
    const { myData } = this.props;
    const rows = myData || [];

    return (
      <Fragment>
        <div className="mh-table-wrap">
          <table className="table mh-table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Date</th>
                <th scope="col">Category</th>
                <th scope="col">Sub Category</th>
                <th scope="col">Note</th>
                <th scope="col">Amount</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={6} className="mh-empty">
                    No entries for this month.
                  </td>
                </tr>
              ) : (
                rows.map((expense, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{expense.date}</td>
                    <td>
                      <span className={`mh-badge ${categoryColorClass(expense.category)}`}>
                        {expense.category}
                      </span>
                    </td>
                    <td>{subCategoryBadge(expense.subCategory)}</td>
                    <td>{expense.note}</td>
                    <td>
                      <span className="mh-amount-pill">{expense.amount}Tk</span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <ToastContainer />
      </Fragment>
    );
  }
}

export default Datatable;
